module.exports = __webpack_public_path__ + "img/1.deb8c487.jpeg";